import React, { useCallback } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, Select } from '@occc-app/design-system';
import { pluralize } from '@occc-app/lib/strings';
import {
  lastVisitOperatorsOptions,
  lastVisitTimePeriodOptions,
} from '@occc-app/routes/Audience/components/FuelAndConvenienceProfile/constants';
import { parseNumber } from '@occc-app/lib/finalFormUtils';

import { UnArray } from '../../../../typings/utils';

export type LastVisitTargetingAttributeProps = {
  lastVisitFieldName: string;
  lastVisitAmount?: number | null;
};

export const LastVisitTargetingAttribute = ({
  lastVisitFieldName,
  lastVisitAmount,
}: LastVisitTargetingAttributeProps) => {
  const pluralizeLabelIfPlural = useCallback(
    (option: UnArray<typeof lastVisitTimePeriodOptions>) => {
      if (option.value === '') {
        return option;
      }
      const { label, value } = option;
      return {
        label: `${pluralize(lastVisitAmount || 0, label)} ago`,
        value,
      };
    },
    [lastVisitAmount],
  );

  return (
    <Grid container spacing={3}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${lastVisitFieldName}.operator`}
          label='Comparison'
          data={lastVisitOperatorsOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <TextField
          name={`${lastVisitFieldName}.amount`}
          label='Days/weeks/months'
          fieldProps={{
            parse: parseNumber,
          }}
        />
      </Grid>

      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${lastVisitFieldName}.period`}
          label='Period'
          data={lastVisitTimePeriodOptions.map(pluralizeLabelIfPlural)}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  );
};
